import { lettersConstants } from "@_constants/letters.constants";
import { lettersService } from "@_services/letters.service";

export const lettersActions = {
  clearStatusMessage,
  downloadLetter,
};

function clearStatusMessage(stateName) {
  return (dispatch) => {
    dispatch(clear(stateName));
  };

  function clear(stateName) {
    return {
      type: lettersConstants.LETTERS_CLEAR_STATUS_MESSAGE,
      stateName,
    };
  }
}

// for now calling the service directly as the handle response helper function is not handling the blob/file recieved from the backend correctly
function downloadLetter(caseId, letterId, action) {
  return (dispatch) => {
    dispatch(request());
    lettersService
      .downloadLetter(caseId, letterId)
      .then(
        (response) => response.blob(),
        (error) => {
          dispatch(failure(error));
        }
      )
      .then(
        (blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/pdf" })
          );
          if (action === "download") {
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", letterId);

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
          } else if (action === "view") {
            window.open(url, "_blank");
          }
          dispatch(success());
        },
        (error) => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: lettersConstants.LETTER_DOWNLOAD_REQUEST };
  }
  function success() {
    return {
      type: lettersConstants.LETTER_DOWNLOAD_SUCCESS,
    };
  }
  function failure(error) {
    return {
      type: lettersConstants.LETTER_DOWNLOAD_FAILURE,
      error,
    };
  }
}
